import { BehaviorSubject } from 'rxjs'
import { AdminTransaction } from '../AdminTransaction'

/**
 * View model for a single historical transaction in the list.
 */
export class HistoricalTransactionViewModel {
  /**
   * Tracks whether the view model is active.
   */
  private readonly _active = new BehaviorSubject<boolean>(false)

  /**
   * Constructor.
   */
  constructor(public readonly transaction: AdminTransaction) {}

  /**
   * Activates the view model.
   */
  activate() {
    this._active.next(true)
  }

  /**
   * Deactivates the view model.
   */
  deactivate() {
    this._active.next(false)
  }
}
